const MuiTextField = {
  defaultProps: {
    inputProps: {
      'data-hj-allow': '',
    },
  },
};

export default MuiTextField;
